// extracted by mini-css-extract-plugin
export default {"Root":"IssueIndicator_Root__BVDfN"};